import { render } from "./AddDemandePrixPage.vue?vue&type=template&id=254b8dc6&ts=true"
import script from "./AddDemandePrixPage.vue?vue&type=script&lang=ts"
export * from "./AddDemandePrixPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__